var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select-search',{attrs:{"name":"warehouse","label":"Warehouse Name","placeholder":"Choose Warehouse","hasClear":false,"data":_vm.warehouses,"selected":_vm.warehouse,"isFullWidth":"","data-cy":_vm.supplierCy.PRODUCTS.STOCKTAKE.CONDUCT_STOCKTAKE.WAREHOUSE.BUTTON__WAREHOUSE},on:{"selected":function($event){_vm.warehouse = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }